// extracted by mini-css-extract-plugin
export default {"root":"styles_root__1KKj7","titleWrapper":"styles_titleWrapper__JMfTZ","title":"styles_title__Hc4vf"};